<template>
  <div class="iframe-wrap" id="main-wrap">
    <iframe
      id="main"
      :src="iframeSrc"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'TtcIframe',
  props: {
  },
  data () {
    return {
      iframeSrc: ''
    }
  },
  mounted () {
    const token = localStorage.getItem('token')
    this.getMenuAuth()
    this.iframeSrc = `${process.env.VUE_APP_TTC_URL}/boardManage/businessKanban?isKanbanIframe=true&token=${token}`
  },
  watch: {

  },
  methods: {
    getMenuAuth () {
      this.$service
        .fetch({
          url: '/api/finance-api/operation/permission'
        })
        .then((res) => {
          this.isQuality = res
          console.log('res-getMenuAuth: ', res)
        })
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
.iframe-wrap{
    width: 100%;
    height: 100vh;
    overflow: hidden;

    #main{
        transform-origin: left top;
    }
}
</style>
